import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import DefaultModal from '../organisms/DefaultModal';
import styled from 'styled-components';
import ModalCookies from '../organisms/ModalCookies';
import { useNavigate } from 'react-router-dom';
import usersRepository from '../../services/repository/users';
import AdmissionMetadata from '../../types/AdmissionMetadata';
import dayjs from 'dayjs';
import { useAuth } from '../../services/context/AuthContext';

const Wrapper = styled.div`
  padding: 32px;
`;

const InfoAccess: React.FC = () => {
  const navigate = useNavigate();
  const [admissionMetadata, setAdmissionMetadata] = useState<AdmissionMetadata>({
    id: '',
    name: '',
    socialName: '',
    email: '',
    cpf: '',
    createdAt: dayjs(),
    professionalIdentification: 0,
    expirationDate: undefined,
  });

  useEffect(() => {
    usersRepository.getCurrentUserAdmissionMetaData().then(data => {
      setAdmissionMetadata(data);
    });
  }, []);

  const formatAdmissionFillTimeLimit = (expirationDate: dayjs.Dayjs) : string => {
    return expirationDate.format('DD/MM/YYYY');
  };

  const { logout } = useAuth();

  return (
    <DefaultModal width={700} showBtnExit={true} squareWidth={'35%'} onLogout={() => {
      navigate('/');
      logout();
    }}>
      {!localStorage.getItem('admissao-digital-cookie') && (
        <ModalCookies />
      )}

      <Wrapper>
        <h2>Olá {admissionMetadata?.socialName || admissionMetadata?.name || ''} pronto para realizar seu processo?</h2>

        <ul>
          <li>
            Para efetuar o seu processo de admissão, vamos precisar que esteja com seus documentos em mãos para facilitar durante o cadastro dos dados.
          </li>

          <li>
            Lembre-se que o tempo é limitado, mas a admissão salva cada etapa concluída e você pode voltar, dentro do prazo determinado, para concluir as próximas etapas.
          </li>

          <li>
            Com todos os dados/campos preenchidos, você seguirá para a etapa final para anexar seus documentos ao portal, e assim todo o processo será finalizado.
          </li>

          <li>
            Antes de finalizar o processo, você poderá voltar às etapas a qualquer momento caso deseje editar alguma informação.
          </li>

          <li>
            Depois de finalizado o processo, seus dados serão enviados ao setor responsável por concluir seu cadastro no sistema. Sendo assim, você não poderá editar mais nenhuma informação.
          </li>
        </ul>

        <h2>Prazo para a conclusão</h2>

        <p>Você tem até <b>{admissionMetadata.expirationDate && formatAdmissionFillTimeLimit(dayjs(admissionMetadata.expirationDate))}</b> para concluir o preenchimento dos dados da admissão.</p>

        <ul>
          <li>
            Ao expirar esse prazo, caso não tenha completado todas as etapas, você perderá o acesso e será considerado que concluiu/desistiu do processo de admissão.
          </li>
        </ul>

        <Button type='primary' onClick={() => navigate('/register')}>Realizar processo de admissão</Button>

        <p>
          OBS: Durante o processo de admissão serão inseridos dados pessoais e documentos. Para sua maior segurança, evite fazer esse processo em computadores de uso público.
        </p>
      </Wrapper>
    </DefaultModal>
  );
};

export default InfoAccess;
